export enum BasicReviewResult {
    APPROVED = 'Approved',
    DECLINED = 'Declined'
}
